import {memo} from 'react';

import styled from 'styled-components';

import {getLocalizationService} from '~/shared/services/localisationService';
import {media} from '~/shared/theme/media';

import ActionButton from './ActionButton';

const actionsConfig = [
  {
    key: 'link_credit_card',
    caption: 'link_credit_card_to_10bis',
  },
  {
    key: 'billing_permissions',
    caption: 'manage_billing_permissions',
  },
  {
    key: 'card_lost_or_stolen',
    caption: 'card_lost_or_stolen',
  },
  {
    key: 'card_worn_or_not_working',
    caption: 'card_worn_or_not_working',
  },
  {
    key: 'cancel_card',
    caption: 'cancel_10bis_card',
  },
];

const Root = styled.div`
  display: flex;
  flex-direction: column;
  ${media.minLargeTablet`
    width: 386px;
  `}
`;

const ActionsSection = () => {
  const {t} = getLocalizationService();

  return (
    <Root>
      {actionsConfig.map((item, index) => (
        <ActionButton key={item.key} caption={t(item.caption)} withBorderTop={index > 0} />
      ))}
    </Root>
  );
};

export default memo(ActionsSection);
